export default [{
	path: '/:amp?/support',
	component: () => import(/* webpackChunkName: 'Support' */ './SupportHome.vue'),
	props: true,
	children: [
		{
			path: '/',
			name: 'support',
			component: () => import(/* webpackChunkName: 'Support' */ './SupportIndex.vue'),
			props: true
		},
		{
			path: 'faq',
			alias: '7/faq',
			name: 'faq',
			component: () => import(/* webpackChunkName: 'Support' */ './FAQIndex.vue'),
			props: true
		},
		{
			alias: 'faq/tags/:tag',
			path: '7/faq/tags/:tag',
			name: 'faq-tag',
			component: () => import(/* webpackChunkName: 'Support' */ './FAQIndex.vue'),
			props: true
		},
		{
			path: ':cfid/faq/:slug?',
			name: 'faq-article',
			component: () => import(/* webpackChunkName: 'Support' */ './FAQIndex.vue'),
			props: true
		},
		{
			path: ':cfid/*',
			name: 'support-article',
			component: () => import(/* webpackChunkName: 'Support' */ './Support.vue'),
			props: true
		},
		// {
		// 	path: 'submit-request',
		// 	name: 'submit-request',
		// 	component: () => import(/* webpackChunkName: 'SupportRequest' */ './SupportRequest.vue')
		// },
		{
			path: 'report-abuse',
			name: 'report-abuse',
			component: () => import(/* webpackChunkName: 'ReportAbuse' */ './ReportAbuse.vue')
		},
		{ path: '*', redirect: '/support' }
	]
}];